import { client } from '@atlassian/rovo-content-bridge-api/client-types';

export const SMART_CREATE_MODAL_CLIENT_ID = client('smart-create-modal');
